import React from 'react';
import { TrustLevel, TRUST_LEVEL_CONFIGS } from '@df-gate-share/shared';

interface RecipientChipProps {
  email: string;
  onRemove: (email: string) => void;
  trustLevel?: TrustLevel;
  displayName?: string;
  isLoading?: boolean;
}

/** Material Symbols icon name mapped from TrustLevelConfig.icon */
const TRUST_ICON_MAP: Record<string, string> = {
  'shield-check': 'verified_user',
  'history': 'history',
  'info-circle': 'info',
  'exclamation-triangle': 'warning',
};

const RecipientChip: React.FC<RecipientChipProps> = ({
  email,
  onRemove,
  trustLevel,
  displayName,
  isLoading,
}) => {
  const config = trustLevel ? TRUST_LEVEL_CONFIGS[trustLevel] : undefined;

  // Determine display text: Level 1 shows displayName, others show email
  const chipText = trustLevel === 1 && displayName ? displayName : email;

  // Determine chip tooltip
  const chipTooltip = trustLevel === 1 && displayName
    ? email // Level 1: show email on hover
    : config?.tooltipTemplate || undefined; // Level 3/4: show warning tooltip

  // CSS class
  const chipClass = [
    'chip',
    isLoading ? 'chip--loading' : '',
    trustLevel ? `chip--trust-${trustLevel}` : '',
  ].filter(Boolean).join(' ');

  return (
    <div className={chipClass} title={chipTooltip}>
      {/* Trust level icon */}
      {isLoading && (
        <span className="chip__trust-icon material-symbols-outlined icon-sm chip__spinner">
          progress_activity
        </span>
      )}
      {!isLoading && config && (
        <span
          className="chip__trust-icon material-symbols-outlined icon-sm"
          title={config.label}
        >
          {TRUST_ICON_MAP[config.icon]}
        </span>
      )}

      {/* Chip text */}
      {chipText}

      {/* Remove button */}
      <button
        onClick={() => onRemove(email)}
        className="chip__remove"
      >
        <span className="material-symbols-outlined icon-sm">close</span>
      </button>
    </div>
  );
};

export default RecipientChip;
